var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"vx-col md:w-1/3 lg:w-1/3 xl:w-1/3 mr-5"},[_c('label',{staticClass:"vs-input--label"},[_vm._v("Sales")]),_c('v-select',{attrs:{"options":_vm.options,"placeholder":"All"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }